// extracted by mini-css-extract-plugin
export default {"wrap":"MF-z","fullWidth":"NF-z","hideOnDesktop":"OF-z","content":"PF-z","hasOpenedNav":"QF-z","crumbsList":"RF-z","dropdownsWrap":"SF-z"};